import * as React from 'react';
import { Box } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState, useTheme } from "react";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SortIcon from '@mui/icons-material/Sort';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import CloseIcon from '@mui/icons-material/Close';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { withRouter } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { Scale } from "@mui/icons-material";
import './pop.css';
import {BiMenuAltRight} from 'react-icons/bi';



const Pop = (props) => {
  const { history } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const itemsList=[{text:"Home", onClick:()=> history.push('/')},
                     {text:"Our Story", onClick:()=> history.push('/story')},
                     {text:"FAQ's", onClick:()=> history.push('/faq')},
                     {text:"Invest Now", onClick:()=> history.push('/invest')},
                     {text:"Careers", onClick:()=> history.push('/career')},
                     {text:"Blog", onClick:()=> history.push('/blog')},
                     {text:"Contact", onClick:()=> history.push('/contact')},
                     
                    ];
  return (
    <div>
      
      <IconButton 
        size='large'
        color='inherit'
        aria-label="logo"
        onClick={handleClick}
        style={{
          zIndex: 99
        }}
        sx={theme => ({ [theme.breakpoints.up('sm')]:{top:'4%',position:'fixed',right:'10%',},
                        
                        [theme.breakpoints.between('0','600')]:{ top:'4%',position:'absolute',right:'5%'}
                      })}
        
        > <BiMenuAltRight fontSize='3.3rem' style={{color:'white',backgroundColor:'#202020',position:'absolute',padding:7,borderRadius:35}} />
          
        </IconButton>
      
      <Menu
        sx={{height:'100%',maxHeight:'100%'}}
        
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
       
        <Box p={3}   textAlign='center'>
          <div className='header-head'>Untouched</div>  
          <CloseIcon onClick={handleClose} sx={{ top:{xs:'1.5%',md:'2.5%'}, position:{xs:'absolute',md:'absolute'}, right:{xs:'4%',md:'6%'}}}/>         
        </Box>
        <List sx={{marginTop:{xs:'5%',md:'0%'}}}>
       {itemsList.map((item, index) => {
           
           const {text,onClick}=item;
           
           return (
               <ListItem    key={text} onClick={() => {
                handleClose();
                onClick();
              }}>
                   <ListItemText  primary={<Typography style={{ fontFamily:'Quicksand',cursor:'pointer',  fontWeight: 900,fontSize:'1rem' }}>
                  
                  {text}
                </Typography>} sx={{'&:hover': {
                        color: '#7D8B71'}, paddingLeft:3,paddingRight:10}} />
               </ListItem> 
           );
           })}
           <Box sx={{marginTop:{xs:'30%',md:'25%'}}}>
          {/* <div  style={{textAlign:"center"}}>
              <div style={{fontFamily:'Quicksand',fontSize:'0.8rem', fontWeight: 100}}>On Social Networks</div>
              <div className='s-grp'>
              <a target='_blank' href="https://www.linkedin.com/company/projectuntouch/"><img style={{width:'25px'}} id="s-icon"src="/images/social-icon/Linkedin White.svg" alt="" /></a>
              <a target='_blank' href="https://twitter.com/projectuntouch"><img style={{width:'25px'}} id="s-icon"src="/images/social-icon/Twitter White.svg" alt="" /></a>
              <a target='_blank' href="https://www.instagram.com/projectuntouched/"><img  style={{width:'25px'}} id="s-icon"src="/images/social-icon/Instagram White.svg" alt="" /></a>
              </div>
          </div> */}
          </Box>
    </List> 
    
      {/* <Box     textAlign="center">
          
      </Box>  */}
        
       
      </Menu>
      
    </div>
  );
}
export default withRouter(Pop);
